<template>
    <div></div>
</template>

<script>
export default {
    name: 'DeleteOrderProduct',
    props: {
        popupDeleteOrder: {
            type: Boolean,
            default: false,
        },
        orderId: Number
    },

    watch: { 
      	popupDeleteOrder: function(newVal) {
            if(newVal == true){
                let orderId = this.orderId + 10000
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: "حذف سفارش",
                    text: `سفارش شماره ${orderId} حذف شود؟`,
                    acceptText: "حذف",
                    cancelText: "انصراف",
                    accept: this.deleteOrder,
                    cancel: this.cancelDelete,
                })
            }            
        },
    },
    
    methods: {
        cancelDelete(){
            this.$emit('updatePopupDeleteOrder', false)
        },

        deleteOrder(){
			this.$vs.loading()
            this.$emit('updatePopupDeleteOrder', false)
			this.$store.dispatch('deleteOrder', this.orderId)
			.then(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'محصول با موفقیت حذف شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
			})
			.catch(() => {
                this.$vs.loading.close()
				this.$vs.notify({
				title: '',
				text: 'خطا در اتصال به اینترنت',
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'warning'
				})
			})
		},
    }
}
</script>